// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8d315422","244":"2c21f206","258":"8400e61e","520":"80c4210b","586":"268f7243","638":"49d6eafe","750":"c1c4d1f0","834":"447b970a","975":"8c40f619"}[chunkId] + ".chunk.js";
};